<template>
  <div @click="toggleClick">
    <svg-icon icon-class="icon-arrow-right" class="wscn-icon hamburger" :class="{'is-active':isActive}" />
  </div>
</template>

<script>
export default {
  name: 'Hamburger',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    toggleClick: {
      type: Function,
      default: null
    }
  }
}
</script>

<style scoped lang="scss">
@import "src/styles/variables.scss";

.hamburger {
  display: inline-block;
  cursor: pointer;
  width: 20px;
  height: 20px;
  transform: rotate(0deg);
  transition: 0.3s;
  transform-origin: 50% 50%;
  position: relative;
  top: 10px;
  right: 10px;
  color: #5c5c5c;
}

.hamburger.is-active {
  transform: rotate(180deg);
  position: relative;
  right: 0px;
  transition: 0.3s;
}
.svg-icon {
  margin-right: 0;
}
</style>
